module.exports = __webpack_public_path__ + "static/media/moons_advanced-1800.9cfc93d6.webp";